import CalendarInput from 'components/CalendarInput/CalendarInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Flex, PageFooter } from 'styling/GlobalStyles'
import { OtherText, TitleText } from 'styling/Typography'
import { IconContainer } from '../Accommodation.style'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { WhitePersonIcon } from '../icons/WhitePersonIcon'
import { formatDateForDisplay, getParams, handlePagination } from 'utils/helpers'
import { Pagination } from 'components/Pagination/Pagination'
import { useEffect, useState } from 'react'
import { getBedsHistory } from 'features/accommodation/accommodationSlice'
import { ISelectValue } from 'constants/globalTypes'

export const BedHistory = () => {
    const [params, setParams] = useState(getParams({ location, limit: 30 }))
    const { bedsHistory } = useSelector((state: RootState) => state.accomodation)
    const dispatch = useDispatch<AppDispatch>()

    const NoBeds = () => {
        return <Flex center justcenter height='100%' column gap='1rem' >
            <IconContainer>
                <WhitePersonIcon />
            </IconContainer>
            <TitleText>No History Available for selected filters</TitleText>
        </Flex>
    }

    useEffect(() => {
        dispatch(getBedsHistory(params))
    }, [params])

    const columns: IHonestTableColumn<any>[] = [
        {
            id: 'person',
            header: 'Person',
            cell: (bed) => (
                <Flex column gap='0.5rem' >
                    <TitleText>{bed.user ? (bed.user.firstName + ' ' + bed.user.lastName) : (bed.accommodationGuest?.firstName + ' ' + bed.accommodationGuest?.lastName)}</TitleText>
                    <OtherText grey>ID: {bed.accommodationGuest ? bed.accommodationGuest?.identificationNumber : bed.user?.id}</OtherText>
                </Flex>
            ),
        },
        {
            id: 'type',
            header: 'Type',
            cell: (bed) => <StatusPill status={bed.personType == 1 ? 'info' : 'neutral'}>{bed.personType == 1 ? 'Employee' : 'Guest'}</StatusPill>,
        },
        { id: 'bed', header: 'Bed', cell: (bed) => <TitleText>Bed {bed?.bed?.label} </TitleText> },
        { id: 'location', header: 'Location', cell: (bed) => <TitleText>{bed?.campName} / {bed?.blockName} / {bed?.roomName}</TitleText> },
        { id: 'checkIn', header: 'Check-In', cell: (bed) => <TitleText>{formatDateForDisplay(bed.checkInTimestamp)}</TitleText> },
        { id: 'checkOut', header: 'Check-Out', cell: (bed) => <TitleText>{formatDateForDisplay(bed.expectedCheckOutTimestamp)}</TitleText> },
        { id: 'checkOverride', header: 'Check-Override', cell: (bed) => <TitleText>{bed?.overrideReason ? 'YES' : 'NO'}</TitleText> },
    ]

    return <Flex column gap='1rem' >

        <Flex gap='1rem' >
            <CalendarInput width='250px' labelText='Date From' nomarg defaultValue={params.dateFrom ? new Date(params.dateFrom) : null} onChange={d => setParams(prev => ({ ...prev, dateFrom: d }))} maxDate={params.dateTo ? new Date(params.dateTo) : null} />
            <CalendarInput width='250px' labelText='Date To' nomarg defaultValue={params.dateTo ? new Date(params.dateTo) : null} onChange={d => setParams(prev => ({ ...prev, dateTo: d }))} minDate={params.dateFrom ? new Date(params.dateFrom) : null} />
            {/* <HonestSelectInput onChange={null} options={[]} labelText='Camp' />
                <HonestSelectInput onChange={null} options={[]} labelText='Block' /> */}
            <HonestSelectInput width='250px' nomarg defaultValue={params.personType} onChange={(v: ISelectValue) => setParams(prev => ({ ...prev, personType: v.value }))} options={[{ label: 'Employee', value: 1 }, { label: 'Guest', value: 2 }]} labelText='Person Type' />
        </Flex>
        <Flex gap='1rem' >
            <StatusPill status='info' dot>Completed {bedsHistory.completedCount || '0'}</StatusPill>
            <StatusPill status='success' dot>Active {bedsHistory.activeCount || '0'}</StatusPill>
            <StatusPill status='danger' dot>Overdue {bedsHistory.overdueCount || '0'}</StatusPill>
        </Flex>
        {bedsHistory.data.length === 0 ? <NoBeds /> : <HonestTable columns={columns} data={bedsHistory.data} keyField='id' />}
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(bedsHistory.totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>

    </Flex >
}